// import React, { useState, lazy, Suspense } from "react";
// import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
// import Sidebar from "./components/Sidebar";
// import Login from "./pages/Login";
// import ResetPassword from "./pages/ResetPassword";
// import LandingPage from "./pages/LandingPage";
// import ProfilePage from "./pages/ProfilePage";
// import { getProfile } from "./api";

// const DashboardOverview = lazy(() => import("./pages/DashboardOverview"));
// const Organizations = lazy(() => import("./pages/Organizations"));
// const Subscriptions = lazy(() => import("./pages/Subscriptions"));
// const AccessControl = lazy(() => import("./pages/AccessControl"));
// const EmployeeManagement = lazy(() => import("./pages/EmployeeManagement"));
// const RolePermission = lazy(() => import("./pages/RolePermission"));
// const SessionManagement = lazy(() => import("./pages/SessionManagement"));
// const AttendanceManagement = lazy(() => import("./pages/AttendanceManagement"));
// const EmployeeProfile = lazy(() => import("./pages/EmployeeProfile"));
// const GetSupport = lazy(() => import("./pages/GetSupport"));
// const SupportTicket = lazy(() => import("./pages/SupportTicket"));
// function PrivateRoute({ children }) {
//   const user = localStorage.getItem("user");
//   if (!user) return <Navigate to="/login" replace />;
//   return children;
// }

// const routeMap = {
//   "/dashboard-overview": "dashboard-overview",
//   "/organizations":      "organizations",
//   "/subscriptions":      "subscriptions",
//   "/access-control":     "access-control",
//   "/employee":           "employee",
//   "/role":               "role",
//   "/session":            "session",
//   "/attendance":         "attendance",
//   "/profile":            "profile",
//   "/getsupport":         "getsupport",
//   "/supportticket":      "supportticket",
// };

// function MainApp() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [previewEmployee, setPreviewEmployee] = useState(null);
//   const { data: profileData, isLoading } = useQuery({ queryKey: ["profile"], queryFn: getProfile, staleTime: 5 * 60 * 1000 });

//   const role = profileData?.user?.role?.toLowerCase();

//   // profile load hone tak blank screen nahi, sidebar bhi wait kare
//   if (isLoading) return (
//     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "#f8fafc" }}>
//       <div style={{ fontSize: 14, color: "#94a3b8" }}>Loading...</div>
//     </div>
//   );

//   // employee role restricted
//   if (role === "employee") return (
//     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", background: "#f8fafc", gap: 12 }}>
//       <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
//       <h2 style={{ fontSize: 22, fontWeight: 700, color: "#1e293b", margin: 0 }}>Access Restricted</h2>
//       <p style={{ fontSize: 14, color: "#64748b", textAlign: "center", maxWidth: 360 }}>This portal is designed for Admins and Training Coordinators. It is not intended for Employees.</p>
//     </div>
//   );

//   const active = routeMap[location.pathname] || (role === "super admin" ? "dashboard-overview" : "employee");

//   if (previewEmployee) {
//     return (
//       <Suspense fallback={null}>
//         <EmployeeProfile employee={previewEmployee} onBack={() => setPreviewEmployee(null)} />
//       </Suspense>
//     );
//   }

//   return (
//     <div style={styles.layout}>
//       <Sidebar active={active} setActive={(key) => navigate(`/${key}`)} />
//       <main style={styles.main}>
//         <div style={styles.topbar}>
//           <img
//             src={profileData?.user?.profilePhoto || "https://i.pravatar.cc/100"}
//             alt="avatar"
//             style={styles.avatar}
//             onClick={() => navigate("/profile")}
//           />
//         </div>
//         <div style={styles.content}>
//           <Suspense fallback={<div style={styles.loader}>Loading...</div>}>
//             <Routes>
//               <Route path="dashboard-overview" element={<DashboardOverview />} />
//               <Route path="organizations" element={<Organizations />} />
//               <Route path="subscriptions" element={<Subscriptions />} />
//               <Route path="access-control" element={<AccessControl />} />
//               <Route path="employee"   element={<EmployeeManagement onPreview={(emp) => setPreviewEmployee(emp)} userRole={profileData?.user?.role?.toLowerCase()} />} />
//               <Route path="role"       element={<RolePermission />} />
//               <Route path="session"    element={<SessionManagement />} />
//               <Route path="attendance" element={<AttendanceManagement />} />
//               <Route path="profile"    element={<ProfilePage onBack={() => navigate(-1)} />} />
//               <Route path="getsupport" element={<GetSupport />} />
//               <Route path="supportticket" element={<SupportTicket />} />
//               <Route path="*"          element={<EmployeeManagement onPreview={(emp) => setPreviewEmployee(emp)} />} />
//             </Routes>
//           </Suspense>
//         </div>
//       </main>
//     </div>
//   );
// }

// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/"                       element={<LandingPage />} />
//         <Route path="/login"                  element={<Login />} />
//         <Route path="/reset-password/:token"  element={<ResetPassword />} />
//         <Route path="/*" element={<PrivateRoute><MainApp /></PrivateRoute>} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// const styles = {
//   layout:  { display: "flex", height: "100vh", overflow: "hidden", background: "#f1f5f9", fontFamily: "'Segoe UI', sans-serif" },
//   main:    { flex: 1, overflowY: "auto", display: "flex", flexDirection: "column" },
//   topbar:  { position: "sticky", top: 0, zIndex: 100, display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "12px 32px", borderBottom: "1px solid #e2e8f0", background: "#080e21" },
//   avatar:  { width: 36, height: 36, borderRadius: "50%", objectFit: "cover", cursor: "pointer" },
//   content: { padding: 32, flex: 1 },
//   loader:  { padding: 32, color: "#94a3b8", fontSize: 14 },
// };



import React, {
  useState,
  lazy,
  Suspense,
  useEffect,
} from "react";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { Menu, X } from "lucide-react";

import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import LandingPage from "./pages/LandingPage";
import ProfilePage from "./pages/ProfilePage";

import { getProfile } from "./api";


const DashboardOverview = lazy(() =>
  import("./pages/DashboardOverview")
);

const Organizations = lazy(() =>
  import("./pages/Organizations")
);

const Subscriptions = lazy(() =>
  import("./pages/Subscriptions")
);

const AccessControl = lazy(() =>
  import("./pages/AccessControl")
);

const EmployeeManagement = lazy(() =>
  import("./pages/EmployeeManagement")
);

const RolePermission = lazy(() =>
  import("./pages/RolePermission")
);

const SessionManagement = lazy(() =>
  import("./pages/SessionManagement")
);

const AttendanceManagement = lazy(() =>
  import("./pages/AttendanceManagement")
);

const EmployeeProfile = lazy(() =>
  import("./pages/EmployeeProfile")
);

const GetSupport = lazy(() =>
  import("./pages/GetSupport")
);

const SupportTicket = lazy(() =>
  import("./pages/SupportTicket")
);


function PrivateRoute({ children }) {
  const user = localStorage.getItem("user");

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}


const routeMap = {
  "/dashboard-overview": "dashboard-overview",
  "/organizations": "organizations",
  "/subscriptions": "subscriptions",
  "/access-control": "access-control",
  "/employee": "employee",
  "/role": "role",
  "/session": "session",
  "/attendance": "attendance",
  "/profile": "profile",
  "/getsupport": "getsupport",
  "/supportticket": "supportticket",
};


function MainApp() {

  const navigate = useNavigate();
  const location = useLocation();

  const [previewEmployee, setPreviewEmployee] =
    useState(null);

  // Mobile sidebar open/close
  const [mobileMenuOpen, setMobileMenuOpen] =
    useState(false);

  // Check mobile screen
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );


  const {
    data: profileData,
    isLoading,
  } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
    staleTime: 5 * 60 * 1000,
  });


  const role =
    profileData?.user?.role?.toLowerCase();


  // Detect screen size
  useEffect(() => {

    const handleResize = () => {

      setIsMobile(
        window.innerWidth <= 768
      );

    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };

  }, []);


  // Route change hone par mobile sidebar close
  useEffect(() => {

    setMobileMenuOpen(false);

  }, [location.pathname]);


  if (isLoading) {

    return (
      <div style={styles.loadingScreen}>
        <div style={styles.loadingText}>
          Loading...
        </div>
      </div>
    );

  }


  // Employee restricted
  if (role === "employee") {

    return (
      <div style={styles.restrictedScreen}>

        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#cbd5e1"
          strokeWidth="1.5"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
          />

          <line
            x1="12"
            y1="8"
            x2="12"
            y2="12"
          />

          <line
            x1="12"
            y1="16"
            x2="12.01"
            y2="16"
          />
        </svg>


        <h2 style={styles.restrictedTitle}>
          Access Restricted
        </h2>


        <p style={styles.restrictedText}>
          This portal is designed for Admins
          and Training Coordinators. It is not
          intended for Employees.
        </p>

      </div>
    );

  }


  const active =
    routeMap[location.pathname] ||
    (
      role === "super admin"
        ? "dashboard-overview"
        : "employee"
    );


  if (previewEmployee) {

    return (
      <Suspense fallback={null}>

        <EmployeeProfile
          employee={previewEmployee}
          onBack={() =>
            setPreviewEmployee(null)
          }
        />

      </Suspense>
    );

  }


  // Navigation function
 const handleNavigation = (key) => {
  navigate(`/${key}`);
  setMobileMenuOpen(false);
};


  return (

    <div style={styles.layout}>


      {/* ========================= */}
      {/* DESKTOP SIDEBAR */}
      {/* ========================= */}

      {!isMobile && (

        <Sidebar
          active={active}
          setActive={handleNavigation}
        />

      )}


      {/* ========================= */}
      {/* MOBILE OVERLAY */}
      {/* ========================= */}

      {isMobile &&
        mobileMenuOpen && (

          <div
            style={styles.overlay}
            onClick={() =>
              setMobileMenuOpen(false)
            }
          />

        )}


      {/* ========================= */}
      {/* MOBILE SIDEBAR */}
      {/* ========================= */}

      {isMobile && (

        <div
          style={{
            ...styles.mobileSidebar,
            transform: mobileMenuOpen
              ? "translateX(0)"
              : "translateX(-100%)",
          }}
        >

          {/* Close button */}

          <button
            onClick={() =>
              setMobileMenuOpen(false)
            }
            style={styles.closeButton}
          >

            <X size={24} />

          </button>


          <Sidebar
            active={active}
            setActive={handleNavigation}
          />

        </div>

      )}


      {/* ========================= */}
      {/* MAIN */}
      {/* ========================= */}

      <main style={styles.main}>


        {/* ========================= */}
        {/* TOP BAR */}
        {/* ========================= */}

        <div
          style={{
            ...styles.topbar,

            padding: isMobile
              ? "10px 16px"
              : "12px 32px",
          }}
        >


          {/* MOBILE MENU BUTTON */}

          {isMobile && (

            <button
              onClick={() =>
                setMobileMenuOpen(true)
              }
              style={styles.menuButton}
            >

              <Menu size={24} />

            </button>

          )}


          {/* PROFILE */}

          <img
            src={
              profileData?.user?.profilePhoto ||
              "https://i.pravatar.cc/100"
            }
            alt="avatar"
            style={styles.avatar}
            onClick={() =>
              navigate("/profile")
            }
          />

        </div>


        {/* ========================= */}
        {/* PAGE CONTENT */}
        {/* ========================= */}

        <div
          style={{
            ...styles.content,

            padding: isMobile
              ? "16px"
              : "32px",
          }}
        >

          <Suspense
            fallback={
              <div style={styles.loader}>
                Loading...
              </div>
            }
          >

            <Routes>

              <Route
                path="dashboard-overview"
                element={
                  <DashboardOverview />
                }
              />

              <Route
                path="organizations"
                element={
                  <Organizations />
                }
              />

              <Route
                path="subscriptions"
                element={
                  <Subscriptions />
                }
              />

              <Route
                path="access-control"
                element={
                  <AccessControl />
                }
              />

              <Route
                path="employee"
                element={
                  <EmployeeManagement
                    onPreview={(emp) =>
                      setPreviewEmployee(emp)
                    }
                    userRole={
                      profileData?.user?.role?.toLowerCase()
                    }
                  />
                }
              />

              <Route
                path="role"
                element={
                  <RolePermission />
                }
              />

              <Route
                path="session"
                element={
                  <SessionManagement />
                }
              />

              <Route
                path="attendance"
                element={
                  <AttendanceManagement />
                }
              />

              <Route
                path="profile"
                element={
                  <ProfilePage
                    onBack={() =>
                      navigate(-1)
                    }
                  />
                }
              />

              <Route
                path="getsupport"
                element={
                  <GetSupport />
                }
              />

              <Route
                path="supportticket"
                element={
                  <SupportTicket />
                }
              />

              <Route
                path="*"
                element={
                  <EmployeeManagement
                    onPreview={(emp) =>
                      setPreviewEmployee(emp)
                    }
                  />
                }
              />

            </Routes>

          </Suspense>

        </div>

      </main>

    </div>

  );
}


export default function App() {

  return (

    <BrowserRouter>

      <Routes>

        <Route
          path="/"
          element={
            <LandingPage />
          }
        />

        <Route
          path="/login"
          element={
            <Login />
          }
        />

        <Route
          path="/reset-password/:token"
          element={
            <ResetPassword />
          }
        />

        <Route
          path="/*"
          element={
            <PrivateRoute>
              <MainApp />
            </PrivateRoute>
          }
        />

      </Routes>

    </BrowserRouter>

  );
}


const styles = {

  layout: {
    display: "flex",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    background: "#f1f5f9",
    fontFamily:
      "'Segoe UI', sans-serif",
  },


  main: {
    flex: 1,
    minWidth: 0,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
  },


  topbar: {
    position: "sticky",
    top: 0,
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 62,
    boxSizing: "border-box",
    borderBottom:
      "1px solid #e2e8f0",
    background: "#080e21",
  },


  menuButton: {
    width: 40,
    height: 40,
    border: "none",
    borderRadius: 8,
    background: "#14212d",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },


  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 20,
    width: 38,
    height: 38,
    border: "none",
    borderRadius: 8,
    background: "#14212d",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },


  mobileSidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    width: 280,
    height: "100vh",
    zIndex: 1001,
    background: "#080e21",
    transition:
      "transform 0.3s ease",
    boxShadow:
      "8px 0 25px rgba(0,0,0,0.3)",
  },


  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "rgba(0,0,0,0.55)",
    zIndex: 1000,
  },


  avatar: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    objectFit: "cover",
    cursor: "pointer",
  },


  content: {
    flex: 1,
    minWidth: 0,
    boxSizing: "border-box",
  },


  loader: {
    padding: 32,
    color: "#94a3b8",
    fontSize: 14,
  },


  loadingScreen: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    background: "#f8fafc",
  },


  loadingText: {
    fontSize: 14,
    color: "#94a3b8",
  },


  restrictedScreen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    padding: 20,
    boxSizing: "border-box",
    background: "#f8fafc",
    gap: 12,
  },


  restrictedTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: "#1e293b",
    margin: 0,
  },


  restrictedText: {
    fontSize: 14,
    color: "#64748b",
    textAlign: "center",
    maxWidth: 360,
    lineHeight: 1.6,
    margin: 0,
  },

};

